import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useTheme } from 'styled-components';
import { Text } from '..';
import { StyledInput, StyledLabel, StyledRadio, StyledWrapper, } from './Radio.style';
export function Radio({ label, name, size = 'Medium', checked = false, disabled = false, onClick, }) {
    const [isChecked, setIsChecked] = useState(checked);
    const onClickHandler = () => {
        if (disabled)
            return;
        setIsChecked(!isChecked);
        onClick(!isChecked);
    };
    useEffect(() => {
        setIsChecked(checked);
    }, [checked]);
    const theme = useTheme();
    return (_jsxs(StyledWrapper, { onClick: onClickHandler, disabled: disabled, children: [_jsx(StyledRadio, { disabled: disabled, radioSize: size, checked: isChecked, children: _jsx(StyledInput, { type: "radio", name: name, radioSize: size, checked: isChecked, disabled: disabled, readOnly: true }) }), label && (_jsx(StyledLabel, { children: _jsx(Text, { size: "Body", color: disabled ? theme.Color.Neutrals.Gray : theme.Color.Neutrals.Dark, children: label }) }))] }));
}
//# sourceMappingURL=Radio.js.map